import { GridApi } from 'ag-grid-community';
import { useContext, useState } from 'react';
import { createContext } from 'react';

type GridApiContextType = {
  api: GridApi<any> | null;
  setApi: (api: GridApi<any>) => void;
};

const GridContext = createContext<GridApiContextType | null>(null);

export function useGridApiContext() {
  const context = useContext(GridContext);
  return context;
}

export function WithGridApiContext({ children }: { children: React.ReactNode }) {
  const [api, setApi] = useState<GridApi<any> | null>(null);
  return <GridContext.Provider value={{ api, setApi }}>{children}</GridContext.Provider>;
}
